import React, { createRef, useState, useEffect } from 'react';
import { useRecoilState } from 'recoil'
import styled from 'styled-components';
import { media, bp } from './Common/styles/responsive';
import HeaderNavigater from './Common/Component/HeaderNavigater';
import Company from './Screen/Company'; 
import SideNav from './Screen/SideNavi';
import DynamicSidebar from './Common/Component/DynamicSidebar';
import AddItem from './Screen/AddItem';
import BuyItem from './Screen/BuyItem';
import Pay from './Screen/Pay';
import Cart from './Screen/Cart';
import { Route, Switch, Link, Redirect, useHistory, useLocation } from 'react-router-dom';
import Logo from '../src/images/Logo.png';
import { MarketHeader as Header, Storefront as Shop, MarketFooter as Footer, MarketProduct } from './market/Storefront';
import DetailPage from './Screen/Detail';
import AdminDashboard from './Screen/Admin';
import AdminMembers from './Screen/Admin/Members';
import AdminAnalytics from './Screen/Admin/Analytics';
import AdminCoupons from './Screen/Admin/Coupons';
import AdminDatabase from './Screen/Admin/Database';
import AdminInventory from './Screen/Admin/Inventory';
import AdminMarketing from './Screen/Admin/Marketing';
import AdminNotifications from './Screen/Admin/Notifications';
import AdminOrders from './Screen/Admin/Orders';
import AdminPoints from './Screen/Admin/Points';
import AdminProducts from './Screen/Admin/Products';
import AgentSubmissions from './Screen/Admin/AgentSubmissions';
import AdminSideNavigator from './Common/Component/AdminSideNavigator';
import About from './Screen/About';
import Support from './Screen/Support';
import MyPage from './Screen/MyPage';
import Coupon from './Screen/Coupon';
import SystemGuide from './Screen/SystemGuide';
import AdminManagement from './Screen/Admin/Management';
import CompanyInfo from './Screen/CompanyInfo';
import OrderHistory from './Screen/OrderHistory';
import DeliveryTracking from './Screen/DeliveryTracking';
import PointCharge from './Screen/PointCharge';
import OrderDetail from './Screen/OrderDetail';

const AppContainer = styled.div`
  max-width: var(--market-max-w);
  margin: 0 auto;
  position: relative;
  background: #fff;
  min-height: 100vh;
`;

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* 헤더가 fixed 라 그만큼 비워 둔다. 높이는 index.css 가 갖고 있고 좁은
   * 화면에서 알아서 줄어든다. */
  padding-top: var(--market-header-h);
`;

const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: var(--market-max-w);
  /* 높이를 못 박지 않는다. 좁은 화면에서 헤더 안쪽이 줄바꿈되면 못 박은
   * 높이 밖으로 내용이 삐져나온다. */
  min-height: var(--market-header-h);
  z-index: 1000;
  background: #fff;
  box-shadow: none;
`;

const MainContent = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  /* 사이드바가 이 줄의 한 칸을 실제로 차지한다. 예전에는 사이드바가
   * position:absolute 이고 본문이 margin-left 로 피하는 식이었는데, 그
   * margin 이 1200px 이하에서 0 이 되면서도 사이드바는 그대로 떠 있어서
   * 본문이 사이드바 밑으로 들어가 글자가 가려졌다. */
  align-items: stretch;
`;

const ContentSection = styled.section`
  flex: 1 1 auto;
  /* 이게 없으면 안쪽 표·슬라이더가 넘칠 때 flex 칸이 같이 늘어나서
   * 페이지 전체가 가로로 밀린다. */
  min-width: 0;
  padding: ${props => props.isFullPage ? '0' : 'var(--market-gutter)'};
  min-height: calc(100vh - 300px);
  background: #fff;
`;

const ProductGrid = styled.div`
  display: grid;
  /* auto-fill + minmax 은 좁아지면 저절로 한 줄에 적게 담는다. 다만 최소값이
   * 250px 이면 폰(360px)에서 한 칸도 안 들어가 삐져나오므로 min() 으로
   * 화면 폭에 양보시킨다. */
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 220px), 1fr));
  gap: var(--market-gutter);
  margin-top: 20px;

  ${media.sm} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
`;

const ProductCard = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  transition: all 0.2s;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
`;

const ProductImage = styled.div`
  width: 100%;
  /* 높이를 못 박으면 칸이 좁아져도 이미지 자리만 그대로 남아 카드가 세로로
   * 길쭉해진다. 비율로 두면 폭을 따라 같이 줄어든다. */
  aspect-ratio: 4 / 3;
  background: #f3f4f6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  color: #9ca3af;
  font-size: 14px;
`;

/* 서랍 뒤를 덮는 막. 여기를 누르면 닫힌다 — 좁은 화면에서 닫는 X 버튼
 * 하나만 두면 못 찾는 사람이 많다. */
const Scrim = styled.div`
  position: fixed;
  inset: var(--market-header-h) 0 0 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 1050;
  ${media.wide} {
    display: none;
  }
`;

const ProductName = styled.h4`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #111827;
`;

const ProductPrice = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`;

const CategoryTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #111827;
`;

const ProductCount = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin: 0 0 30px 0;
  line-height: 1.5;
`;

function App() {
  const history = useHistory();
  const location = useLocation();
  const [selectedCategory, setSelectedCategory] = useState('전체');
  const [selectedBrand, setSelectedBrand] = useState('전체');
  const [filteredProducts, setFilteredProducts] = useState([]);

  // 더미 상품 데이터
  const dummyProducts = [
    { id: 1, name: '클래식 티셔츠', category: '의류', brand: 'NIKE', price: 35000, image: '/images/shirt1.jpg' },
    { id: 2, name: '캐주얼 팬츠', category: '의류', brand: 'ADIDAS', price: 45000, image: '/images/pants1.jpg' },
    { id: 3, name: '스니커즈', category: '신발', brand: 'NIKE', price: 89000, image: '/images/shoes1.jpg' },
    { id: 4, name: '백팩', category: '가방', brand: 'ADIDAS', price: 55000, image: '/images/bag1.jpg' },
    { id: 5, name: '스마트워치', category: '전자제품', brand: 'APPLE', price: 299000, image: '/images/watch1.jpg' },
    { id: 6, name: '무선 이어폰', category: '전자제품', brand: 'APPLE', price: 129000, image: '/images/earphone1.jpg' },
    { id: 7, name: '원피스', category: '의류', brand: 'NIKE', price: 65000, image: '/images/dress1.jpg' },
    { id: 8, name: '러닝화', category: '신발', brand: 'ADIDAS', price: 79000, image: '/images/sneakers1.jpg' },
    { id: 9, name: '토트백', category: '가방', brand: 'NIKE', price: 42000, image: '/images/tote1.jpg' },
    { id: 10, name: '노트북', category: '전자제품', brand: 'APPLE', price: 899000, image: '/images/laptop1.jpg' },
    { id: 11, name: '청바지', category: '의류', brand: 'ADIDAS', price: 52000, image: '/images/jeans1.jpg' },
    { id: 12, name: '구두', category: '신발', brand: 'NIKE', price: 95000, image: '/images/shoes2.jpg' },
    { id: 13, name: '크로스백', category: '가방', brand: 'ADIDAS', price: 38000, image: '/images/crossbag1.jpg' },
    { id: 14, name: '태블릿', category: '전자제품', brand: 'APPLE', price: 499000, image: '/images/tablet1.jpg' },
    { id: 15, name: '후드티', category: '의류', brand: 'NIKE', price: 28000, image: '/images/hoodie1.jpg' }
  ];

  // 필터 함수
  const applyFilters = (category = selectedCategory, brand = selectedBrand) => {
    let filtered = dummyProducts;
    
    if (category !== '전체') {
      filtered = filtered.filter(product => product.category === category);
    }
    
    if (brand !== '전체') {
      filtered = filtered.filter(product => product.brand === brand);
    }
    
    setFilteredProducts(filtered);
  };

  const handleFilter = (category) => {
    setSelectedCategory(category);
    applyFilters(category, selectedBrand);
  };

  const handleBrandFilter = (brand) => {
    setSelectedBrand(brand);
    applyFilters(selectedCategory, brand);
  };

  // 초기 로드 시 전체 상품 표시
  useEffect(() => {
    setFilteredProducts(dummyProducts);
  }, []);

  // 관리자 페이지인지 확인
  const [isAdminPage, setIsAdminPage] = useState(false);
  const isShopPage = ['/', '/Home', '/Shop', '/ShowItem', '/Cart', '/BuyItem', '/pay'].includes(location.pathname) || location.pathname.startsWith('/product/') || location.pathname.startsWith('/ShowItem/');

  // 좁은 화면에서 사이드바는 서랍이 된다. 열림 여부를 여기서 들고 있는 것은
  // 여는 버튼이 헤더에 있고 서랍은 사이드바이기 때문이다 — 둘의 공통 부모가
  // 여기다.
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    setIsAdminPage(location.pathname.startsWith('/admin'));
  }, [location.pathname]);

  // 메뉴를 눌러 페이지가 바뀌면 서랍은 닫혀야 한다. 안 닫으면 이동한 화면이
  // 서랍에 가려 아무것도 안 보인다.
  useEffect(() => { setNavOpen(false); }, [location.pathname]);

  // 넓어지면 서랍 개념 자체가 없어진다. 열어 둔 채로 화면을 돌리면(폴드를
  // 펴면) 막만 남아 화면을 못 누르게 된다.
  useEffect(() => {
    const onResize = () => { if (window.innerWidth > bp.lg) setNavOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // 서랍이 열린 동안 뒤가 따라 스크롤되지 않게.
  useEffect(() => {
    document.body.classList.toggle('market-drawer-open', navOpen);
    return () => document.body.classList.remove('market-drawer-open');
  }, [navOpen]);

  const hasSidebar = isAdminPage || !isShopPage;

  return (
    <AppContainer>
      <AppWrapper>
        <HeaderWrapper>
          <Header
            onMenuToggle={hasSidebar ? () => setNavOpen((v) => !v) : null}
            menuOpen={navOpen}
          />
        </HeaderWrapper>
        <MainContent>
          {isAdminPage ? (
            <AdminSideNavigator open={navOpen} onClose={() => setNavOpen(false)} />
          ) : !isShopPage ? (
            <DynamicSidebar
              onCategoryFilter={handleFilter}
              selectedCategory={selectedCategory}
              onBrandFilter={handleBrandFilter}
              selectedBrand={selectedBrand}
              open={navOpen}
              onClose={() => setNavOpen(false)}
            />
          ) : null}
          {navOpen && hasSidebar && <Scrim onClick={() => setNavOpen(false)} />}
          <ContentSection isAdmin={isAdminPage} isFullPage={isShopPage}>
            <Switch>
              {/* Affiliate-only public storefront: retain legacy code, disable direct checkout routes. */}
              <Route exact path={['/Cart', '/BuyItem', '/pay']}><Redirect to="/ShowItem" /></Route>
              <Route exact path="/" component={Shop} key="Home" />
              <Route exact path="/BuyItem" component={BuyItem} key="BuyItem" />
              <Route exact path="/AddItem" component={AddItem} key="AddItem" />
              <Route exact path="/ShowItem" render={() => (
                <Shop
                  selectedCategory={selectedCategory}
                  selectedBrand={selectedBrand}
                />
              )} key="ShowItem" />
              <Route exact path="/pay" component={Pay} key="Pay" />
              <Route exact path="/Cart" component={Cart} key="Cart" />
              <Route exact path="/Home" component={Shop} key="HomeAlias" />
              <Route exact path="/Shop" component={Shop} key="ShopPage" />
              <Route exact path="/ViewItem:product_id" component={DetailPage} key="Detail" />
              <Route exact path="/product/:id" component={MarketProduct} key="ProductDetail" />
              <Route path="/ShowItem/:collection" component={Shop} />
              <Route exact path="/admin" component={AdminDashboard} key="AdminDashboard" />
              <Route exact path="/admin/members" component={AdminMembers} key="AdminMembers" />
              <Route exact path="/admin/management" component={AdminManagement} key="AdminManagement" />
              <Route exact path="/admin/analytics" component={AdminAnalytics} key="AdminAnalytics" />
              <Route exact path="/admin/coupons" component={AdminCoupons} key="AdminCoupons" />
              <Route exact path="/admin/database" component={AdminDatabase} key="AdminDatabase" />
              <Route exact path="/admin/inventory" component={AdminInventory} key="AdminInventory" />
              <Route exact path="/admin/marketing" component={AdminMarketing} key="AdminMarketing" />
              <Route exact path="/admin/notifications" component={AdminNotifications} key="AdminNotifications" />
              <Route exact path="/admin/orders" component={AdminOrders} key="AdminOrders" />
              <Route exact path="/admin/points" component={AdminPoints} key="AdminPoints" />
              <Route exact path="/admin/products" component={AdminProducts} key="AdminProducts" />
              <Route exact path="/admin/agent-submissions" component={AgentSubmissions} key="AgentSubmissions" />
              <Route exact path="/about" component={About} key="About" />
              <Route exact path="/support" component={Support} key="Support" />
              <Route exact path="/mypage" component={MyPage} key="MyPage" />
              <Route exact path="/coupon" component={Coupon} key="Coupon" />
              <Route exact path="/system-guide" component={SystemGuide} key="SystemGuide" />
              <Route exact path="/company-info" component={CompanyInfo} key="CompanyInfo" />
              <Route exact path="/order-history" component={OrderHistory} key="OrderHistory" />
              <Route exact path="/delivery-tracking" component={DeliveryTracking} key="DeliveryTracking" />
              <Route exact path="/point-charge" component={PointCharge} key="PointCharge" />
              <Route exact path="/order-detail/:orderId" component={OrderDetail} key="OrderDetail" />
              <Route exact path="/support/faq" render={() => {
                const FAQ = require('./Screen/Support/FAQ').default;
                return <FAQ />;
              }} key="FAQ" />
              <Route exact path="/support/contact" render={() => {
                const Contact = require('./Screen/Support/Contact').default;
                return <Contact />;
              }} key="Contact" />
              <Route exact path="/support/notice" render={() => {
                const Notice = require('./Screen/Support/Notice').default;
                return <Notice />;
              }} key="Notice" />
              <Route exact path="/quote-request" render={() => {
                const QuoteRequest = require('./Screen/QuoteRequest').default;
                return <QuoteRequest />;
              }} key="QuoteRequest" />
              
              {/* Delivery Tracking sub pages */}
              <Route exact path="/delivery-tracking/status" render={() => {
                const DeliveryStatus = require('./Screen/DeliveryTracking/Status').default;
                return <DeliveryStatus />;
              }} key="DeliveryStatus" />
              <Route exact path="/delivery-tracking/history" render={() => {
                const DeliveryHistory = require('./Screen/DeliveryTracking/History').default;
                return <DeliveryHistory />;
              }} key="DeliveryHistory" />
              <Route exact path="/delivery-tracking/schedule" render={() => {
                const DeliverySchedule = require('./Screen/DeliveryTracking/Schedule').default;
                return <DeliverySchedule />;
              }} key="DeliverySchedule" />
              <Route exact path="/delivery-tracking/returns" render={() => {
                const ReturnsTracking = require('./Screen/DeliveryTracking/Returns').default;
                return <ReturnsTracking />;
              }} key="ReturnsTracking" />
              <Route exact path="/delivery-tracking/guide" render={() => {
                const DeliveryGuide = require('./Screen/DeliveryTracking/Guide').default;
                return <DeliveryGuide />;
              }} key="DeliveryGuide" />
              
              {/* Quote Request sub pages */}
              <Route exact path="/quote-request/calculator" render={() => {
                const QuoteCalculator = require('./Screen/QuoteRequest/Calculator').default;
                return <QuoteCalculator />;
              }} key="QuoteCalculator" />
              <Route exact path="/quote-request/my-quotes" render={() => {
                const MyQuotes = require('./Screen/QuoteRequest/MyQuotes').default;
                return <MyQuotes />;
              }} key="MyQuotes" />
              <Route exact path="/quote-request/in-progress" render={() => {
                const InProgressQuotes = require('./Screen/QuoteRequest/InProgress').default;
                return <InProgressQuotes />;
              }} key="InProgressQuotes" />
              <Route exact path="/quote-request/completed" render={() => {
                const CompletedQuotes = require('./Screen/QuoteRequest/Completed').default;
                return <CompletedQuotes />;
              }} key="CompletedQuotes" />
              <Route exact path="/quote-request/templates" render={() => {
                const QuoteTemplates = require('./Screen/QuoteRequest/Templates').default;
                return <QuoteTemplates />;
              }} key="QuoteTemplates" />
              
            </Switch>
          </ContentSection>
        </MainContent>
        <Footer />
      </AppWrapper>
    </AppContainer>
  );
}

export default App;
